import {SearchX} from "lucide-react";

export const DataState = ({title, copy, items = []}) => (
    <article className="admin-card admin-state">
        <div className="admin-state-icon">
            <SearchX size={18} />
        </div>
        <p className="admin-card-title">{title}</p>
        {copy && <p className="admin-card-note">{copy}</p>}
        {items.length > 0 && (
            <ul className="admin-placeholder-list">
                {items.map((item) => (
                    <li key={item}>{item}</li>
                ))}
            </ul>
        )}
    </article>
);
